import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import ContentSkeleton from '@/components/ui/ContentSkeleton.jsx';

export const PortalLocaleReadiness = createContext(true);

// Body-mounted primitives inherit the same React context even though they sit
// outside the shell DOM. Preserve their DOM/ref/animation structure and state.
export function usePortalLocaleVisibility(style) {
  const ready = useContext(PortalLocaleReadiness);
  return ready ? {} : { hidden: true, inert: '', style: { ...style, display: 'none' } };
}

// A semantic presentation boundary for the authenticated shell.
// Its children stay mounted: reads, drafts, files and dialog identity are retained.
export function PortalLocaleContent({ children }) {
  const ready = useContext(PortalLocaleReadiness);
  return <div hidden={!ready} inert={!ready ? '' : undefined} style={ready ? { display: 'contents' } : undefined} data-portal-locale-content>{children}</div>;
}

export function PortalLocalePresentation({ children }) {
  const ready = useContext(PortalLocaleReadiness);
  return <>
    {!ready && <div className="p-6" data-portal-locale-pending><ContentSkeleton rows={5} /></div>}
    <PortalLocaleContent>{children}</PortalLocaleContent>
  </>;
}

PortalLocaleContent.propTypes = { children: PropTypes.node };
PortalLocalePresentation.propTypes = { children: PropTypes.node };
